import React from 'react'
import BarGraph from './BarGraph';
import Lead from './Lead';
import Funnel from './Funnel';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "../chatAiComponents/ChatAi.css"

const Analytics = (props) => {
  let navigate = useNavigate();


    props.pageTypeHandler("Analytics");

    useEffect(()=>{
      const uData = JSON.parse(localStorage.getItem("userData"));
      if(uData?.stripeData?.stripe_day_count === 0){
        navigate(`/404`);
      }
    },[])


  return (
    <div className='bg-gray-100'>
      {/* Analytics Data */}
      <div className='h-[100vh] pt-[4rem] overflow-y-auto listing'>
        <Funnel authToken={props.authToken}/>
      </div>
        
    </div>
  )
}

export default Analytics